import React from 'react'
import PlayArrowIcon from 'components/material-symbol/icons/PlayArrow'
import MaterialSymbol from 'components/material-symbol/material-symbol'

const PauseIcon = props => (
  <MaterialSymbol name="pause" fontSize={24} htmlColor="#172024" {...props} />
)

const MessagingPlayButton = ({ isPlaying, onClick }) => (
  <button
    type="button"
    className="str-chat__message-attachment-audio-widget--play-button"
    data-testid={isPlaying ? 'pause-audio' : 'play-audio'}
    onClick={onClick}
  >
    {isPlaying ? (
      <PauseIcon />
    ) : (
      <PlayArrowIcon fontSize={24} htmlColor="#172024" />
    )}
  </button>
)

export default MessagingPlayButton
